import { createSlice } from "@reduxjs/toolkit";

//stored session: data will not present on diff tab
const initialState = {
  constants: [],
  table: {
    page: 1,
    limit: 50,
    searchText: "",
    searchBy: "all",
    results: [],
  },
  temp: "",
  selectedCustomers: [],
  selectedAssets: [],
  pathname: "",
};

export const constantSlice = createSlice({
  name: "constants",
  initialState,
  reducers: {
    setConstants: (state, { payload }) => {
      return {
        ...state,
        constants: payload,
      };
    },
    setTemp: (state, { payload }) => {
      return {
        ...state,
        temp: payload,
      };
    },
    setTableFilter: (state, { payload }) => {
      return {
        ...state,
        table: { ...state.table, ...payload },
      };
    },
    clearFilter: (state, { payload = {} }) => {
      return {
        ...state,
        table: initialState.table,
      };
    },
    setCustomers: (state, { payload = [] }) => {
      return {
        ...state,
        selectedCustomers: payload,
      };
    },
    setAssets: (state, { payload = [] }) => {
      return {
        ...state,
        selectedAssets: payload,
      };
    },
    setPathname: (state, { payload }) => {
      return {
        ...state,
        pathname: payload,
      };
    },
  },
});

export const {
  setConstants,
  setTableFilter,
  clearFilter,
  setTemp,
  setCustomers,
  setAssets,
  setPathname,
} = constantSlice.actions;

export default constantSlice.reducer;
